import { API_URL } from '../api';
const API = API_URL;

export const coverSrc = (url) => (url ? (url.startsWith('http') ? url : `${API}${url}`) : null);

async function request(path, { token, method = 'GET', body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw Object.assign(new Error(data.error || 'Erreur serveur'), { status: res.status });
  }
  return data;
}

// Public
export const fetchArticles = () => request('/api/articles').then(d => d.articles);
export const fetchArticle = (slug) => request(`/api/articles/${encodeURIComponent(slug)}`).then(d => d.article);

// Admin (jeton requis)
export const adminListArticles = (token) => request('/api/admin/articles', { token }).then(d => d.articles);
export const adminGetArticle = (token, id) => request(`/api/admin/articles/${id}`, { token }).then(d => d.article);
export const adminSaveArticle = (token, id, body) =>
  request(id ? `/api/admin/articles/${id}` : '/api/admin/articles', { token, method: id ? 'PUT' : 'POST', body }).then(d => d.article);
export const adminDeleteArticle = (token, id) => request(`/api/admin/articles/${id}`, { token, method: 'DELETE' });

export const formatArticleDate = (date) => (date
  ? new Date(String(date).replace(' ', 'T')).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
  : '');

// Temps de lecture estimé (≈ 200 mots/minute)
export const readingTime = (content = '') => Math.max(1, Math.round(content.split(/\s+/).length / 200));
